import { Controller, useFormContext } from "react-hook-form";

import { Paper } from "@mui/material";
import Grid from "@mui/material/Grid";

import { ChartOfAccountTypeEnum } from "@/features/chart-of-accounts";
import { OutletChartOfAccountSelect } from "@/features/outlet-chart-of-accounts";
import { CustomInputField } from "@/features/ui";

export const OtherSection = () => {
  const {
    register,
    control,
    watch,
    formState: { errors },
  } = useFormContext();

  const buyer = watch("buyer");

  return (
    <Paper sx={{ p: 2.5, borderRadius: 2 }}>
      <Grid container spacing={2.5}>
        <Grid size={{ xs: 12, lg: 6 }}>
          <Controller
            control={control}
            name="outletChartOfAccount"
            render={({ field, fieldState }) => (
              <OutletChartOfAccountSelect
                value={field.value}
                onChange={field.onChange}
                outletId={buyer?.id}
                types={[ChartOfAccountTypeEnum.CASH_AND_BANK]}
                TextFieldProps={{
                  label: "Kas & Bank",
                  required: true,
                  error: fieldState.invalid,
                  helperText: fieldState.error?.message,
                  InputProps: {
                    placeholder: "Pilih Kas & Bank",
                  },
                }}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }}>
          <CustomInputField
            name="note"
            label="Catatan"
            register={register}
            helperText={errors.note?.message}
            error={Boolean(errors.note)}
            InputProps={{
              multiline: true,
              minRows: 2,
              maxRows: 3,
            }}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};
